import { z } from 'zod';

interface FieldFunction {
  label: string;
  action: string;
  id: string;
}

interface FieldFilling {
  id: string | number;
  nameActive: boolean;
  name: string;
  isRequired: boolean;
  allowReset: boolean;
  currentFunctions: FieldFunction[];
}

const FieldFunctionSchema = z.object({
  label: z.string(),
  action: z.string(),
  id: z.string()
});

const FieldFillingSchema: z.ZodSchema<FieldFilling> = z.lazy(() =>
  z.object({
    id: z.string().or(z.number()),
    nameActive: z.boolean(),
    name: z.string(),
    isRequired: z.boolean(),
    allowReset: z.boolean(),
    currentFunctions: z.array(FieldFunctionSchema)
  })
);

const objectForSelection = {
  id: z.string().or(z.number()),
  label: z.string()
};

export const ProcessingWorkOrdersSchema = z.object({
  id: z.number().or(z.string()),
  name: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите название процесса' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    })
    .or(z.number()),
  description: z.string(),
  statusesTransitions: z
    .array(
      z.object({
        id: z.string().or(z.number()),
        name: z
          .string()
          .min(1, { message: 'Укажите название действия' })
          .refine((value) => value.trim().length > 0, {
            message: 'Поле не может содержать только пробелы'
          }),
        fromTaskStatus: z.object(objectForSelection),
        toTaskStatus: z.object(objectForSelection),
        // roles: z.array(z.string()).optional(),
        priority: z.number().or(z.null()).or(z.string()).optional(),
        // fieldFilling: z.array(FieldFillingSchema).optional()
        visibleOnMap: z.boolean().optional().default(false)
      })
    )
    .optional(),
  closingTaskStatuses: z.array(
    z.object({
      id: z.string().or(z.number()),
      label: z.string()
    })
  ).min(1, { message: 'Пожалуйста, выберите закрывающий статус' }),
});
